if (!customElements.get('engraving-selector')) {
  customElements.define(
    'engraving-selector',
    class EngravingSelector extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          propertyName: this.dataset.propertyName,
          productFormWebComponent: 'product-form',
          productFormSelector: 'product-form form',
          productAddToCartSelector: 'button.product-form__submit',
          variantPersonalised: this.dataset.variantPersonalised,
          variantPlayer: this.dataset.variantPlayer
        };
        this.playerBlock = this.querySelector('#number-player');
        this.customBlock = this.querySelector('#custom-name');
        this.customNumber = this.customBlock.querySelector('input[name="dorsal"]');
        this.customName = this.customBlock.querySelector('input[name="player"]');
        this.selectPlayer = this.querySelector('select#player');

        this.addEventListeners();
      }

      connectedCallback() {
        setTimeout(() => {
          let propertyNameLower = this.selectors.propertyName.toLowerCase();
          let variantFieldset = document.querySelector(`fieldset.variant-type-${propertyNameLower}`);
          if (variantFieldset) {
            const selectedInput = variantFieldset.querySelector('input:checked');
            this.toggleBlocks(selectedInput.value, !selectedInput.classList.contains('disabled'));
            this.clearCustom();
          }
        }, 250);
      }

      addEventListeners() {
        this.selectPlayer.addEventListener('change', this.changePlayer.bind(this));
        this.customNumber.addEventListener('keyup', this.onNumbersType.bind(this));
        this.customNumber.addEventListener('change', this.onChangeNumber.bind(this));
        this.customName.addEventListener('keyup', this.onNameType.bind(this));
        this.customName.addEventListener('change', this.onChangeName.bind(this));
      }

      displayEngraving(event) {
        const fieldset = event.target.closest('fieldset');
        let propertyNameLower = this.selectors.propertyName.toLowerCase();
        if (fieldset.classList.contains(`variant-type-${propertyNameLower}`)) {
          const selectedInput = fieldset.querySelector('input:checked');
          this.toggleBlocks(selectedInput.value, !selectedInput.classList.contains('disabled'));
        }
      }

      changePlayer(event) {
        this.changeProperty(event.target.value);
      }

      onNumbersType(event) {
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
        this.countCharacters(event);
      }

      onNameType(event) {
        this.countCharacters(event);
      }

      onChangeNumber(event) {
        this.changeProperty(`${event.target.value} - ${this.customName.value}`);
      }

      onChangeName(event) {
        this.changeProperty(`${this.customNumber.value} - ${event.target.value}`);
      }

      changeProperty(propertyValue) {
        let [number, name] = propertyValue ? propertyValue.split(' - ') : ['', ''];
        number = number.trim() === '' ? '**' : number;
        name = name.trim() === '' ? '**' : name;

        const productForm = document.querySelector(this.selectors.productFormSelector);
        const propertyField = productForm.querySelector(`input[name="properties[${this.selectors.propertyName}]"]`);
        propertyField.value = `${number} | ${name}`;
      }

      clearCustom() {
        this.customNumber.value = '';
        this.customName.value = '';
      }

      toggleBlocks(variantName, available = true) {
        this.removePropertyField();

        if (variantName === this.selectors.variantPlayer) {
          this.showPlayerBlock(available);
        } else if (variantName === this.selectors.variantPersonalised) {
          this.showCustomBlock(available);
        } else {
          this.hideBlocks();
        }
      }

      showPlayerBlock(available) {
        this.customBlock.setAttribute('hidden', false);
        this.playerBlock.removeAttribute('hidden');
        this.toggleAvailability(this.selectPlayer, available);
        this.clearCustom();
        this.createPropertyField();
        this.changeProperty(this.selectPlayer.value);
      }

      showCustomBlock(available) {
        this.playerBlock.setAttribute('hidden', false);
        this.customBlock.removeAttribute('hidden');
        this.toggleAvailability(this.customNumber, available);
        this.toggleAvailability(this.customName, available);
        this.createPropertyField();
      }

      hideBlocks() {
        this.customBlock.setAttribute('hidden', true);
        this.playerBlock.setAttribute('hidden', true);
        this.clearCustom();
      }

      toggleAvailability(element, available) {
        if (available) {
          element.removeAttribute('disabled');
        } else {
          element.setAttribute('disabled', true);
        }
      }

      createPropertyField() {
        const propertyField = document.createElement('input');
        propertyField.setAttribute('type', 'hidden');
        propertyField.setAttribute('name', `properties[${this.selectors.propertyName}]`);
        document.querySelector(this.selectors.productFormSelector).appendChild(propertyField);
      }

      removePropertyField() {
        const productForm = document.querySelector(this.selectors.productFormSelector);
        const propertyField = productForm.querySelector(`input[name="properties[${this.selectors.propertyName}]"]`);
        if (propertyField) {
          propertyField.remove();
        }
      }

      countCharacters(event) {
        const maxNumOfChars = event.target.getAttribute('maxlength');
        const counterElement = event.target.closest('.input').querySelector('.character-counter span');
        counterElement.innerText = `${event.target.value.length}/${maxNumOfChars}`;
      }
    }
  );
}